/**
 * Tiny CSV exporter — keeps two admin pages free of duplicated quoting
 * logic. Handles commas, quotes, and newlines in cell values per RFC 4180.
 *
 * Usage:
 *   exportCsv("filename.csv", [
 *     ["Header A", "Header B"],
 *     ["row1a", "row1b"],
 *   ]);
 */
const csvCell = (v) => {
  if (v === null || v === undefined) return "";
  const s = typeof v === "string" ? v : String(v);
  // Per RFC 4180: wrap in quotes if the cell contains a comma, quote, or
  // newline. Inner quotes are escaped by doubling.
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
};

export function toCsv(rows) {
  return rows.map(row => row.map(csvCell).join(",")).join("\r\n");
}

export function exportCsv(filename, rows) {
  // Prepend a UTF-8 BOM so Excel opens non-ASCII characters correctly out
  // of the box (matters for international names + organizations).
  const blob = new Blob(["\uFEFF" + toCsv(rows)], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Async-revoke after a tick so iOS Safari has time to start the download.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
